import React, { useEffect, useState } from "react";

const Counter = (props) => {
    const [seconds, setSeconds] = useState(props.seconds);
    useEffect(() => {
        if (seconds!==0) {
            setTimeout(() => { setSeconds(seconds - 1); }, 1000);
        } else {
            props.onFinished();
        }
    })
    return (
        <span>
            {seconds}
        </span>
    );
}
export default Counter;